<template>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouvel article
    </button>

    <DataTableBackend :url="'/api/'+table" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
</template>
    
<script >
import { defineAsyncComponent } from 'vue';
import ShowArticle from './ShowArticle.vue';
const FormArticle = defineAsyncComponent(() => import('@/views/parc-auto/articles/FormArticle.vue'));

export default {
    name: 'IndexArticle',
    data() {
        return {
            table: 'articles',
            baseUrl: this.$store.state.api_yams_livraisons,
            isLoading: false,
            columns: [
                {
                    key: 'reference',
                    label: 'Reference',
                },
                {
                    key: 'nom',
                    label: 'Libelle',
                    exportable: true
                },
                {
                    key: 'qte',
                    label: 'QTE',
                    exportable: true
                },
                {
                    key: 'types_article.libelle',
                    label: 'Type',
                    exportable: true
                }
            ]
        }
    },
    methods: {
        openCreateModal() {
            this.$dialog.open(FormArticle, {
                props: {
                    header: "Nouvel article",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowArticle, {
                props: {
                    header: "Article N°"+objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        }
    }
}
</script>
